"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateGetStateLabel = void 0;

var validateGetStateLabel = function validateGetStateLabel(_ref) {
  var countryIso = _ref.countryIso,
      i18n = _ref.i18n;
  if (!countryIso) throw new Error('`countryIso` argument is missing');
  if (!i18n.province) throw new Error('`i18n.province` argument is missing');
  if (!i18n.area) throw new Error('`i18n.area` argument is missing');
  if (!i18n.state) throw new Error('`i18n.state` argument is missing');
};

exports.validateGetStateLabel = validateGetStateLabel;